import { create } from "zustand";
import { persist } from "zustand/middleware";

export const SupportedLanguages = {
  SPANISH: "es",
} as const;

export type Language = (typeof SupportedLanguages)[keyof typeof SupportedLanguages];

type LanguageStore = {
  language: Language;
  setLanguage: (lang: Language) => void;
  initializeLanguage: () => Language;
};

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: "es",
      setLanguage: () => set({ language: "es" }),
      initializeLanguage: () => {
        set({ language: "es" });
        return "es";
      },
    }),
    {
      name: "language-storage",
    },
  ),
);
